import axios from "axios";

const API_BASE_URL = "http://localhost:8080/api"; // Adjust to your actual base

export const bookTrip = async ({
  userId,
  tripId,
  tripTitle,
  noOfTravellers,
  travelDate,
  travellers,
}) => {
  return axios.post(`${API_BASE_URL}/bookings`, {
    userId,
    tripId,
    tripTitle,
    noOfTravellers,
    travelDate,
    travellers,
  });
};
